<img src="assets/icons/AZ_logo_blue.PNG" style="width: 250px; height: 100px" class="right">
<div layout="column" layout-align="start left" style="background-color: #cccccc; height: 100px">
  <table style="height: 100px;border: none;">
    <tbody>
    <tr>
      <td align="center" style="background-color: #0072c0;border: none;width: 250px">
        <p class="label-text_gevo" style="color: white">{{labelText}}</p>
      </td>
      <td style="background-color: #cccccc;border: none;width: auto">
        <p class="benutzerinfo">{{templateText}}</p>
      </td>
      <td style="background-color: #cccccc;border: none;width: auto">
        <div *ngIf="userInfo">
          <p class="benutzerinfo"><i>{{userInfo.bensl}}</i></p>
          <p class="benutzerinfo"><i>{{userInfo.vorname}} {{userInfo.name}}</i></p>
          <p class="benutzerinfo"><i><b>{{userInfo.rolle}} </b> [VTNR-Berechtigungen: {{userInfo.rights}}]</i></p>
          <p class="benutzerinfo"><i>{{tagesDatum  | date:"dd.MM.yyyy"}}</i></p>
        </div>
        <!--<div *ngIf="!angualar.isUndefined(userInfo.rights)" >-->
          <!--<ul *ngFor="let right of userInfo.rights">-->
            <!--<li>{{right}}</li>-->
          <!--</ul>-->
        <!--</div>-->
      </td>
    </tr>
    </tbody>
  </table>
</div>
